import { Injectable } from '@angular/core';

interface CacheRecordStructure {
    etag: string;
    body: any;
}

const key_prefix = 'fi_http_';

@Injectable()
export class FiBackendCacheService {
    getCacheItem(key): CacheRecordStructure {
        const item = localStorage.getItem('fi_http_' + key);
        if (!item) return null;
        return JSON.parse(item);
    }

    setCacheItem(key, value: CacheRecordStructure) {
        localStorage.setItem(key_prefix + key, JSON.stringify(value));
    }

    deleteCacheItems(shouldDeleteFn: (key: string) => boolean) {
        for (let prop in localStorage) {
            if (prop.indexOf(key_prefix) === 0) {
                const key = prop.substring(key_prefix.length);
                if (shouldDeleteFn(key)) {
                    localStorage.removeItem(prop);
                }
            }
        }
    }
}
